import { render, staticRenderFns } from "./freq.vue?vue&type=template&id=7a4b9b10&scoped=true"
import script from "./freq.vue?vue&type=script&lang=js"
export * from "./freq.vue?vue&type=script&lang=js"
import style0 from "./freq.vue?vue&type=style&index=0&id=7a4b9b10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4b9b10",
  null
  
)

export default component.exports